/**
 * Servis işçisi kaydı. Görevi yalnızca UYGULAMA KABUĞUNU önbelleğe almak —
 * veri önbelleği YOK. Veri OPFS'te ve Worker'ın denetiminde; servis işçisinin
 * ona karışması eski veri göstermeye yol açardı.
 */

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  // Geliştirme sunucusunda kayıt yapmıyoruz: modül grafiği sürekli değişiyor.
  if (import.meta.env.DEV) return;

  globalThis.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((error: unknown) => {
      console.warn("Servis işçisi kaydedilemedi (uygulama çevrimiçi çalışmaya devam eder):", error);
    });
  });
}
